<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12">
        <el-form-item label="套餐名称" prop="name">
          <el-input v-model="addEditForm.name" placeholder="请输入套餐名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="套餐价格" prop="price">
          <el-input type="number" v-model="addEditForm.price" placeholder="请输入套餐价格(元)"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属餐厅" prop="restaurantid">
          <el-select v-fixZoom :disabled="!addEditObj.isAdd" v-model="addEditForm.restaurantid" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="changeRestaurant">
            <el-option v-for="item in restaurants" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="套餐描述" prop="">
          <el-input v-model="addEditForm.desc" placeholder="请输入套餐描述"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div style="margin: 0 0 0 20px;overflow-y: auto">
      <div style="margin: 10px 0;">
        <el-input v-model="searchName" placeholder="请输入菜品名称搜索" clearable
          @input="searchIngredientByName" style="width: 300px;">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <span style="font-size: 12px;color: #999999">请选择餐厅菜品</span>
      </div>
      <el-table height="240px" ref="multiple" tooltip-effect="dark" size="mini" border :data="selectIngredientArr" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"/>
        <el-table-column label="名称" align="center" prop="name"/>
        <el-table-column
          label="总卡路里"
          width="70"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.dish_kcal !== ''">{{scope.row.dish_kcal}} kcal</span>
          </template>
        </el-table-column>
        <el-table-column label="营养成分">
          <template slot-scope="scope">
            <div v-if="scope.row.nutrients !== ''">
              <span>碳水化合物:{{scope.row.nutrients.CHO}}克</span><br>
              <span>蛋白质:{{scope.row.nutrients.PRO}}克</span><br>
              <span>脂肪:{{scope.row.nutrients.FAT}}克</span><br>
              <span>糖类:{{scope.row.nutrients.SUG}}克</span><br>
              <span>膳食纤维:{{scope.row.nutrients.DF}}克</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <input style="width: 90%;height: 26px;border: 1px solid #cccccc" type="number" v-model="scope.row.cnt" placeholder="请输入数量"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-form>

  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {adddishpackage, updatedishpackage} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditMeal',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      restaurants: [], // 餐厅
      dishes: [], // 菜品
      selectIngredientArr: [],
      searchName: '', // 添加搜索名称字段
      selectDishes: [],
      addEditForm: {
        id: '',
        name: '',
        restaurantid: '',
        desc: '',
        eid: '',
        price: '',
        dishcnts: []
      },
      addEditRules: {
        name: [
          {required: true, message: '请输入套餐名称', trigger: 'blur'}
        ],
        restaurantid: [
          {required: true, message: '请选择餐厅', trigger: 'change'}
        ],
        price: [
          {required: true, message: '请输入价格', trigger: 'blur'}
        ],
        dishcnts: [
          {required: true, message: '请选择菜品', trigger: 'change'}
        ]
      }
    }
  },
  created () {
    this.restaurants = this.addEditObj.restaurants
    this.addEditObj.dishes.forEach(item => {
      item.nutrients = item.dish_nutrients !== '' ? JSON.parse(item.dish_nutrients) : ''
      this.dishes.push(item)
    })
    if (this.addEditObj.isAdd) {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    } else {
      let row = this.clone(this.addEditObj.row)
      this.addEditForm = {
        id: row.id,
        name: row.name,
        restaurantid: row.restaurantid,
        desc: row.desc,
        eid: row.eid,
        price: row.price,
        dishcnts: row.dishcnts
      }
      let arr = []
      for (let i = 0; i < this.dishes.length; i++) {
        if (this.addEditForm.restaurantid === this.dishes[i].restaurantid) {
          let obj = this.dishes[i]
          obj.desc = ''
          obj.cnt = ''
          arr.push(obj)
        }
      }
      this.selectIngredientArr = arr
      console.log(arr)
      // this.changeRestaurant(row.restaurantid)
    }
  },
  mounted () {
    if (!this.addEditObj.isAdd) {
      let list = []
      this.selectIngredientArr.forEach((item) => {
        this.addEditForm.dishcnts.forEach(val => {
          if (val.id === item.id) {
            item.desc = val.desc
            item.cnt = val.cnt
            list.push(item)
          }
        })
      })
      if (list) {
        list.forEach((row) => {
          this.$refs.multiple.toggleRowSelection(row, true)
        })
      }
    }
  },
  methods: {
    handleSelectionChange (selection) {
      if (selection.length !== 0) {
        // 创建一个Map来存储当前所有选中的项目，避免重复
        const selectedMap = new Map()
        // 将之前选中的但不在当前显示列表中的项目加入Map
        this.addEditForm.dishcnts.forEach(item => {
          if (!this.selectIngredientArr.some(displayItem => displayItem.id === item.id)) {
            selectedMap.set(item.id, item)
          }
        })
        // 将当前选择的项目加入Map（会自动覆盖旧值）
        selection.forEach(item => {
          selectedMap.set(item.id, item)
        })
        // 转换为数组
        this.addEditForm.dishcnts = Array.from(selectedMap.values())
      }
      console.log(99, this.addEditForm.dishcnts)
    },
    searchIngredientByName () {
      console.log('--', this.addEditForm.dishcnts)
      if (!this.searchName) {
        // 如果搜索名称为空，恢复所有菜品
        this.selectIngredientArr = this.selectDishes
      } else {
        // 根据名称过滤菜品（不区分大小写）
        this.selectIngredientArr = this.selectDishes.filter(item =>
          item.name && item.name.toLowerCase().includes(this.searchName.toLowerCase())
        )
      }
      // 在下次DOM更新后重新设置选择状态
      this.$nextTick(() => {
        // 创建已选项目ID的集合，提高查找效率
        const selectedIds = new Set(this.addEditForm.dishcnts.map(item => item.id))
        // 遍历当前显示的项目，恢复选中状态
        this.selectIngredientArr.forEach(row => {
          if (selectedIds.has(row.id)) {
            this.$refs.multiple.toggleRowSelection(row, true)
          }
        })
      })
    },
    changeRestaurant (id) {
      let arr = []
      for (let i = 0; i < this.dishes.length; i++) {
        if (id === this.dishes[i].restaurantid) {
          let obj = this.dishes[i]
          obj.desc = ''
          obj.cnt = '1'
          arr.push(obj)
        }
      }
      this.selectDishes = arr
      this.selectIngredientArr = arr
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let dishcnts = []
          for (let i = 0; i < this.addEditForm.dishcnts.length; i++) {
            if (this.addEditForm.dishcnts[i].cnt === '') {
              this.$message({
                message: '请输入所选菜品数量。',
                type: 'warning'
              })
              return
            }
            let obj = {
              id: this.addEditForm.dishcnts[i].id,
              cnt: parseInt(this.addEditForm.dishcnts[i].cnt),
              desc: this.addEditForm.dishcnts[i].desc
            }
            dishcnts.push(obj)
          }
          if (dishcnts.length === 0) {
            this.$message({
              message: '请选择菜品。',
              type: 'warning'
            })
            return
          }
          if (this.addEditObj.isAdd) {
            let data = {
              name: this.addEditForm.name,
              restaurantid: this.addEditForm.restaurantid,
              eid: this.addEditForm.eid,
              desc: this.addEditForm.desc,
              price: parseFloat(this.addEditForm.price),
              dishcnts: dishcnts
            }
            adddishpackage(data).then(res => {
              this.$notify({title: '成功', message: '成功新增套餐', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            let data = {
              id: this.addEditForm.id,
              name: this.addEditForm.name,
              restaurantid: this.addEditForm.restaurantid,
              eid: this.addEditForm.eid,
              desc: this.addEditForm.desc,
              price: parseFloat(this.addEditForm.price),
              dishcnts: dishcnts
            }
            updatedishpackage(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑套餐', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditMeal.vue